module.exports = __webpack_public_path__ + "static/media/pixxmo.008b546b.webp";